module.exports = __webpack_public_path__ + "static/media/mp.d01d9e28.png";